import { render, staticRenderFns } from "./AdminMessaging.vue?vue&type=template&id=3308984c"
import script from "./AdminMessaging.vue?vue&type=script&lang=js"
export * from "./AdminMessaging.vue?vue&type=script&lang=js"
import style0 from "./AdminMessaging.vue?vue&type=style&index=0&id=3308984c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports